/**
 * webinarDataUid is needed by the BE to identify the webinar in the form submission
 * to display the correct infos in the success message
 */
export function appendDataUid(
    component: HTMLUxIwsWebinarElement,
    webinarDataUid: string
) {
    setAdditionalInfo(component, {
        webinarDataUid,
    });
}

function setAdditionalInfo(component: HTMLUxIwsWebinarElement, data: object) {
    const targetInput = Array.from(
        component.querySelectorAll("form input[type='hidden']")
    ).find((el) => {
        // find the input with the additional-info id like "webinarTestform-968533-additionalinfo"
        return /.+-\d+-additionalinfo/.test(el.id);
    }) as HTMLInputElement;
    if (!targetInput) {
        console.error("No additional-info input found");
        return;
    }
    try {
        const jsonContent = JSON.parse(targetInput.value);
        targetInput.value = JSON.stringify({
            ...jsonContent,
            ...data,
        });
    } catch (e) {
        console.error("Error setting value for additional-info input", e);
    }
}

function setICalDate(component: HTMLUxIwsWebinarElement) {
    const selectedDateInput = component.querySelector(
        "[slot='form'] .radio input:checked"
    );
    if (!selectedDateInput) {
        return;
    }
    const iCalDate = selectedDateInput
        .closest("label")
        .querySelector("ux-date-time").utc;
    setAdditionalInfo(component, {
        iCalDate,
    });
}

export function setFormTitle(
    component: HTMLUxIwsWebinarElement,
    formTitle: string
) {
    const titlePlaceholder = component.querySelector(
        "[slot='form'] .ax_default.heading_2"
    );
    if (titlePlaceholder) {
        titlePlaceholder.innerHTML = `<h2 class="ux-text-headline ux-text-headline--small">${formTitle}</h2>`;
    }
}

export async function setDateFields(
    component: HTMLUxIwsWebinarElement,
    dateFormat: string,
    date1: string,
    date2: string = ""
) {
    const xPathLabel1 = `//span[text()='Date_1']`;
    const xPathLabel2 = `//span[text()='Date_2']`;
    const date1Label = document.evaluate(
        xPathLabel1,
        component.querySelector("[slot='form']"),
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    ).singleNodeValue as HTMLInputElement;
    const date2Label = document.evaluate(
        xPathLabel2,
        component.querySelector("[slot='form']"),
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    ).singleNodeValue as HTMLInputElement;
    date1Label.innerHTML = `<ux-date-time utc="${date1}" format="${dateFormat}"></ux-date-time>`;
    date2Label.innerHTML = `<ux-date-time utc="${date2}" format="${dateFormat}"></ux-date-time>`;
    const date1Input = date1Label?.closest("label").querySelector("input");
    const date2Input = date2Label?.closest("label").querySelector("input");
    date1Input.addEventListener("change", () => setICalDate(component));
    date2Input.addEventListener("change", () => setICalDate(component));
    if (!date2) {
        date1Input.setAttribute("checked", "checked");
        date1Input.closest<HTMLElement>(".powermail_fieldwrap").style.display =
            "none";
    }
    date1Input.value = await getDateString(
        date1Label.querySelector("ux-date-time")
    );
    date2Input.value = await getDateString(
        date2Label.querySelector("ux-date-time")
    );
}

const getDateString = async (
    element: HTMLUxDateTimeElement
): Promise<string> => {
    if (!element.shadowRoot.textContent) {
        return new Promise((resolve) => {
            const observer = new MutationObserver(() => {
                resolve(element.shadowRoot.textContent);
            });
            observer.observe(element.shadowRoot, {
                childList: true,
                subtree: true,
            });
        });
    }
    return element.shadowRoot.textContent;
};

export function addStylesheet(styleSheet: string) {
    const styleId = "ux-iws-webinar-form-styles";
    if (document.getElementById(styleId)) {
        return;
    }
    const style = document.createElement("link");
    style.id = styleId;
    style.rel = "stylesheet";
    style.href = styleSheet;
    document.head.appendChild(style);
}
